import {BASE_API} from "../index";

export const PublicacaoApi = {
  getAll: async (user_uuid, pagina) => {
    let response = await fetch(`${BASE_API}/publicacao`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina
        }
      )
    })
    return await response.json();
  },

  getAllSearch: async (user_uuid, pagina, search) => {
    let response = await fetch(`${BASE_API}/publicacao?search=${search}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina
        }
      )
    })
    return await response.json();
  },

  getAllAdmin: async (user_uuid, pagina, ordem) => {
    let response = await fetch(`${BASE_API}/publicacao/all`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina,
          ordem
        }
      )
    })
    return await response.json();
  },

  getAllAdminSearch: async (user_uuid, pagina, search) => {
    let response = await fetch(`${BASE_API}/publicacao/all?search=${search}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina
        }
      )
    })
    return await response.json();
  },

  setView: async (user_uuid, publicacao_uuid) => {
    let response = await fetch(`${BASE_API}/publicacao/view`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          publicacao_uuid
        }
      )
    })
    return await response.json();
  },

  toggleStatus: async (user_uuid, publicacao_uuid) => {
    let response = await fetch(`${BASE_API}/publicacao/togglestatus`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          publicacao_uuid
        }
      )
    })
    return await response.json();
  },

  getItem: async (user_uuid, publicacao_uuid) => {
    let response = await fetch(`${BASE_API}/publicacao/getitem`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          publicacao_uuid
        }
      )
    })
    return await response.json();
  },
  
  getManual: async () => {
    let response = await fetch(`${BASE_API}/publicacao/getitem`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          publicacao_uuid:"656ef420-ae0e-4630-b0a1-6d76a9d2332b"
        }
      )
    })
    return await response.json();
  },

  create: async (user_uuid, titulo, texto) => {
    let response = await fetch(`${BASE_API}/publicacao/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          titulo,
          texto
        }
      )
    })
    return await response.json();
  },

  update: async (user_uuid, publicacao_uuid, titulo, texto) => {
    let response = await fetch(`${BASE_API}/publicacao/update`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          publicacao_uuid,
          titulo,
          texto
        }
      )
    })
    return await response.json();
  },

  delete: async (user_uuid, publicacao_uuid) => {
    let response = await fetch(`${BASE_API}/publicacao/delete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          publicacao_uuid
        }
      )
    })
    return await response.json();
  }
}